import { supabase } from '../lib/supabase';

/**
 * Login Tracking Service
 * Captures IP, geolocation, browser, and device info on sign-in
 */

function parseUserAgent() {
  const ua = navigator?.userAgent || '';

  // Browser detection
  let browser = 'Unknown';
  if (ua.includes('Firefox/')) browser = 'Firefox';
  else if (ua.includes('Edg/')) browser = 'Edge';
  else if (ua.includes('OPR/') || ua.includes('Opera/')) browser = 'Opera';
  else if (ua.includes('Chrome/') && !ua.includes('Edg/')) browser = 'Chrome';
  else if (ua.includes('Safari/') && !ua.includes('Chrome/')) browser = 'Safari';

  // OS detection
  let os = 'Unknown';
  if (ua.includes('Windows NT 10')) os = 'Windows 10/11';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Linux')) os = 'Linux';

  // Device type
  let deviceType = 'Desktop';
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(ua)) {
    deviceType = /iPad|Tablet/i.test(ua) ? 'Tablet' : 'Mobile';
  }

  return { browser, os, deviceType };
}

async function getGeoLocation() {
  try {
    const response = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
    if (!response.ok) return {};
    const data = await response.json();
    return {
      ip_address: data?.ip || null,
      country: data?.country_name || null,
      country_code: data?.country_code || null,
      city: data?.city || null,
      region: data?.region || null,
      latitude: data?.latitude || null,
      longitude: data?.longitude || null,
      timezone: data?.timezone || null,
    };
  } catch {
    return {};
  }
}

export const loginTrackingService = {
  async trackLogin(userId) {
    if (!userId) return;

    try {
      const [geo, device] = await Promise.all([
        getGeoLocation(),
        Promise.resolve(parseUserAgent()),
      ]);

      await supabase?.from('user_login_logs')?.insert({
        user_id: userId,
        ip_address: geo?.ip_address || null,
        country: geo?.country || null,
        country_code: geo?.country_code || null,
        city: geo?.city || null,
        region: geo?.region || null,
        latitude: geo?.latitude || null,
        longitude: geo?.longitude || null,
        timezone: geo?.timezone || null,
        browser: device?.browser || null,
        os: device?.os || null,
        device_type: device?.deviceType || null,
      });
    } catch (err) {
      console.error('Login tracking error:', err);
    }
  },
};
